import { DataProvider } from 'react-admin';
import { CustomerEvent, CustomerEventType } from '../../types';

interface CreateNoteArgs {
  dataProvider: DataProvider;
  message: string;
  /** When provided, the note is attached to this lead instead of a funeral */
  leadId?: string;
  funeralId?: number;
  userName?: string;
}

/**
 * Create an internal note and return it shaped as a feed event, so callers can
 * drop it straight into the optimistic feed. Shared by the composer's "Note"
 * channel and the standalone Add-note dialog.
 */
export async function createNote({
  dataProvider,
  message,
  leadId,
  funeralId,
  userName,
}: CreateNoteArgs): Promise<CustomerEvent> {
  const noteData: Record<string, any> = {
    message,
    user_name: userName || undefined,
  };
  if (leadId) {
    noteData.lead_id = leadId;
  }
  if (funeralId) {
    noteData.funeral_id = funeralId;
  }

  const { data } = await dataProvider.create('notes', { data: noteData });

  return {
    ...data,
    type: CustomerEventType.INTERNAL_NOTE,
    timestamp: data.created_at,
    message,
    user_name: userName || undefined,
    funeral_id: funeralId || 0,
  } as CustomerEvent;
}
